import { Component, Input, SimpleChanges, ViewChild, OnChanges, AfterViewInit, inject } from '@angular/core';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: '[app-nav-settlements]',
  template: `
    <li><button #condominios class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/condominios">Condominios</button></li>
    <li><button #comercial class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/comercials">Comercial</button></li>
    <li><button #tenants class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/tenants">Inquilinos</button></li>
    <li><button #contratos class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4" routerLink="/contratos">Contratos</button></li>
  `,
  styles: ``
})
export class NavSettlementsComponent implements OnChanges, AfterViewInit {
  profile: any = {};
  permissions: any = {};
  @Input() currentView: string | null = null;
  @ViewChild('condominios') condominios !: any;
  @ViewChild('comercial') comercial !: any;
  @ViewChild('tenants') tenants !: any;
  @ViewChild('contratos') contratos !: any;
  storageService = inject(StorageService);
  constructor() {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentView']) {
      this.currentView = changes['currentView'].currentValue;
      this.updateActiveView();
    }
  }

  ngAfterViewInit() {
    this.updateActiveView();
  }

  private updateActiveView() {
    if (!this.currentView) return;
    
    // Reset all to inactive first
    this.condominios?.nativeElement?.classList.remove('active');
    this.comercial?.nativeElement?.classList.remove('active');
    this.tenants?.nativeElement?.classList.remove('active');
    this.contratos?.nativeElement?.classList.remove('active');

    // Set the appropriate one to active based on currentView
    if (this.currentView === 'condominio' || this.currentView === 'condominios') {
      this.condominios?.nativeElement?.classList.add('active');
    } else if (this.currentView === 'comercial') {
      this.comercial?.nativeElement?.classList.add('active');
    } else if (this.currentView === 'tenants') {
      this.tenants?.nativeElement?.classList.add('active');
    } else if (this.currentView === 'contratos') {
      this.contratos?.nativeElement?.classList.add('active');
    }
  }

  
}
